// extracted by mini-css-extract-plugin
module.exports = {"preFormattedBlock":"PreFormattedBlock-module--preFormattedBlock--TOaB4"};